"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import IconUsers from "@/app/(components)/generics/Icons/IconUsers";
import { useCanRunPaidActions } from "@/app/(components)/specifics/wrappers/BrandProvider/BrandProvider";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { PageParams } from "@/app/types/common/DefaultProps";
import { URLs } from "@/app/utils/URLs";
import { Routes } from "@/app/vars/Routes";
import styles from "./ProspectSearchCard.module.css";

type Props = {
  params: PageParams;
};

export default function ProspectSearchCard(props: Props) {
  const T = useT();
  const { params } = props;

  const canRunPaidActions = useCanRunPaidActions();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.icon}>
          <IconUsers />
        </div>
        <h4 className={styles.title}>{T(TKey.PROSPECT_SEARCH_CARD_TITLE)}</h4>
      </div>

      <p className={styles.desc}>
        {T(
          canRunPaidActions
            ? TKey.PROSPECT_SEARCH_CARD_DESCRIPTION
            : TKey.PROSPECT_SEARCH_CARD_DESCRIPTION_MEMBER,
        )}
      </p>

      <Button
        params={params}
        text={`${T(
          canRunPaidActions ? TKey.PROSPECT_SEARCH_CARD_CTA : TKey.PROSPECT_SEARCH_CARD_CTA_MEMBER,
        )} →`}
        href={URLs.pathOf(Routes.PROTECTED.PROSPECT_SEARCH)}
        type={ButtonType.PRIMARY}
        className={styles.cta}
        min={true}
        isLink={true}
      />
    </div>
  );
}
